import React from "react";
import { ChatMessage } from "../../../../types";
import AsAdmin from "../../session/AsAdmin";

interface Props {
  message?: ChatMessage;
}

export default function MessageTokens(props: Props) {
  const {
    message
  } = props;


  if (!message) {
    return null;
  }

  if (message.role !== "assistant") {
    return null;
  }

  return (
    <AsAdmin>
      <div className="d-flex gap-3 font-code font-xs" style={{ color: "var(--gray-400)" }}>
        <span>IN {message.inputTokens ? message.inputTokens.toFixed(0) : "N/A"} / OUT {message.outputTokens ? message.outputTokens.toFixed(0) : "N/A"}</span>
      </div>
    </AsAdmin>
  )
}